// components/BodyLoader.jsx
import React from "react";

export default function Loader({ show = false }) {
    if (!show) return null;

    return (
        <div className="absolute inset-0 bg-black bg-opacity-30 z-40 flex items-center justify-center">
            <div className="flex flex-col items-center space-y-2">
                <div className="loader border-4 border-t-blue-500 border-gray-200 rounded-full w-12 h-12 animate-spin"></div>
                <p className="text-white text-sm">Processing...</p>
            </div>
        </div>
    );
}
